export default "__VITE_ASSET__865b57a1__"